import { render, staticRenderFns } from "./returnLabel.vue?vue&type=template&id=05292eba&scoped=true&"
import script from "./returnLabel.vue?vue&type=script&lang=js&"
export * from "./returnLabel.vue?vue&type=script&lang=js&"
import style0 from "./returnLabel.vue?vue&type=style&index=0&id=05292eba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05292eba",
  null
  
)

export default component.exports